export default {
    steps: [
        {
            fields: [
                {
                    name: 'giftCardNumber',
                    type: 'text',
                    constraints: [],
                },
                {
                    name: 'cvv',
                    type: 'text',
                    constraints: [
                        {
                            parameters: { max: 3, min: 0 },
                            type: 'length',
                        },
                    ],
                },
            ],
        },
    ],
    submit: '/vouchers',
};
